import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { ButtonDropdown, Button, DropdownItem, Icon, WeezHeader, Tab } from '@weezevent/nacre';
import { CreateModalTemplate } from '@weezevent/templar';

export default function TemplatesTabs({ organizationId, path, index, children }) {
    const { t } = useTranslation();
    const history = useHistory();
    const [activeTab, setActiveTab] = React.useState(() => index);
    const [createTemplateModal, setCreateTemplateModal] = React.useState(false);

    return (
        <>
            <WeezHeader
                title={t('sauron.emails.templates.title')}
                rightComponent={[
                    <ButtonDropdown
                        key={0}
                        trigger={<Button primary icon={<Icon name="plus" />} label={t('common.cta.add')} />}
                        items={[
                            <DropdownItem key={'template'} item={t(`sauron.emails.templates.templates.add`)} onClick={() => setCreateTemplateModal(true)} />,
                            <DropdownItem key={'brandkit'} item={t(`sauron.emails.templates.brandkits.add`)} onClick={() => history.push(`brandkits/new`)} />
                        ]}
                    />
                ]}
            >
                <span>{t('sauron.emails.templates.subtitle')}</span>
            </WeezHeader>
            <CreateModalTemplate organizationId={organizationId} open={createTemplateModal} onClose={() => setCreateTemplateModal(false)} />
            <Tab
                panes={[
                    {
                        id: 0,
                        name: 'templates',
                        menuItem: t('sauron.emails.templates.templates.label'),
                        menuIcon: 'envelope',
                        url: `templates`
                    },
                    {
                        id: 1,
                        name: 'brandkit',
                        menuItem: t('sauron.emails.templates.brandkits.label'),
                        menuIcon: 'color-fill',
                        url: `brandkits`
                    }
                ]}
                activeTab={activeTab}
                onTabSelected={tab => {
                    history.push(tab.url);
                    setActiveTab(tab.id);
                }}
            >
                {React.cloneElement(children, { organizationId, path })}
            </Tab>
        </>
    );
}
